'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _constants = require('../constants');

var _constants2 = _interopRequireDefault(_constants);

var ResponsiveText = (function (_React$Component) {
    _inherits(ResponsiveText, _React$Component);

    function ResponsiveText(props) {
        _classCallCheck(this, ResponsiveText);

        _get(Object.getPrototypeOf(ResponsiveText.prototype), 'constructor', this).call(this, props);
        this.displayName = 'ResponsiveText';
        this.state = {
            windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0
        };
    }

    _createClass(ResponsiveText, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (typeof window !== 'undefined') window.addEventListener('resize', this.handleResize.bind(this));
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (typeof window !== 'undefined') window.removeEventListener('resize', this.handleResize.bind(this));
        }
    }, {
        key: 'handleResize',
        value: function handleResize() {
            this.setState({
                windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props;
            var hiddenXS = _props.hiddenXS;
            var hiddenSM = _props.hiddenSM;
            var hiddenMD = _props.hiddenMD;
            var hiddenLG = _props.hiddenLG;
            var visibleXS = _props.visibleXS;
            var visibleSM = _props.visibleSM;
            var visibleMD = _props.visibleMD;
            var visibleLG = _props.visibleLG;
            var windowWidth = this.state.windowWidth;

            var text = undefined;

            // set widths / flex-basis
            if (windowWidth < _constants2['default'].breakpoint.xs) {
                text = visibleXS || hiddenSM || hiddenMD || hiddenLG;
            } else if (windowWidth < _constants2['default'].breakpoint.sm) {
                text = hiddenXS || visibleSM || hiddenMD || hiddenLG;
            } else if (windowWidth < _constants2['default'].breakpoint.md) {
                text = hiddenXS || hiddenSM || visibleMD || hiddenLG;
            } else {
                text = hiddenXS || hiddenSM || hiddenMD || visibleLG;
            }

            var props = (0, _blacklist2['default'])(this.props, {
                hiddenXS: true,
                hiddenSM: true,
                hiddenMD: true,
                hiddenLG: true,
                visibleXS: true,
                visibleSM: true,
                visibleMD: true,
                visibleLG: true
            });

            return _react2['default'].createElement(
                'span',
                props,
                text
            );
        }
    }]);

    return ResponsiveText;
})(_react2['default'].Component);

ResponsiveText.propTypes = {
    hiddenLG: _propTypes2['default'].string,
    hiddenMD: _propTypes2['default'].string,
    hiddenSM: _propTypes2['default'].string,
    hiddenXS: _propTypes2['default'].string,
    visibleLG: _propTypes2['default'].string,
    visibleMD: _propTypes2['default'].string,
    visibleSM: _propTypes2['default'].string,
    visibleXS: _propTypes2['default'].string
};

module.exports = ResponsiveText;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/ResponsiveText.js
// module id = 326
// module chunks = 0